export default __webpack_public_path__ + "images/gf-695a47d62497dc58466740984bbe3b4f.svg";